var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-dialog',{attrs:{"title":"Leave page","buttons":_vm.buttons},on:{"close":_vm.close},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('div',{staticClass:"leave-dialog"},[_c('div',[_vm._v("Are you sure you want to leave this page?")]),_c('div',[_vm._v("All unsaved changes will be lost.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }